import React, { useEffect } from 'react'

import { NoData, SinglePanePage } from 'styles/shared'
import { color } from 'styles/colors'

import Brand from 'helpers/brand'

import styled from 'styled-components'

import { signOut } from 'aws-amplify/auth'

const SignOut = () => {
  useEffect(() => {
    const amplifySignOut = async () => {
      await signOut()
    }

    amplifySignOut().catch((error) => {
      console.error('Error signing out:', error)
    })
  }, [])

  return (
    <S.PaneContainer>
      <S.TopPane>
        <S.ProductLogo src={Brand.productLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
      </S.TopPane>
      <SinglePanePage>
        <NoData>
          <h1>You are being signed out</h1>
          <h2>You will soon be redirected to the login page.</h2>
        </NoData>
        <S.BrandLogo src={Brand.brandLogoPath()} aria-label="brand-logo" alt={`${Brand.brandLogoPath()} logo`} />
      </SinglePanePage>
    </S.PaneContainer>
  )
}

const S = {
  PaneContainer: styled.div`
    background-color: ${color('background')};
    height: 100%;
  `,
  TopPane: styled(SinglePanePage)`
    height: 150px;
  `,
  LoginPageLink: styled.a`
    color: ${color('anchor')};
    text-decoration: none;
    cursor: pointer;
  `,
  Header: styled.div`
    background-color: ${color('paneBackground')};
  `,
  ProductLogo: styled.img`
    height: 33px;
    float: right;
  `,
  BrandLogo: styled.img`
    height: 40px;
  `
}

export default SignOut
